<script>
   /** @typedef {import('$lib/types').PublicProduct} PublicProduct */
   import { cart } from "$lib/state/cart";
   import AddToCart from "$lib/utils/AddToCartFunction";
 
   /** @type {PublicProduct | ??} */
   export let product;

   /**@type {boolean}*/
   let isInCart;
 
   $: {
     $cart;
     isInCart = $cart?.items.find((item) => item.sku == product?.sku)
       ? true
       : false;
   }
  
   let addToCart = new AddToCart();

   const addSkuToCart = async () => {
     isInCart = true;
     await addToCart.addToCartSingle(product);
   };
 </script>
 
 <button class:incart={isInCart} class="addToBagButton" aria-label={`add product sku ${product?.sku} to cart`} type="submit" on:click={addSkuToCart} />
 
 <style>
   :root {
     --bg: #fff;
     --cross: #000;
     --border: #000;
   }
   .incart {
     --bg: #270404;
     --cross: #fff;
   }
 
   button {
     background-color: transparent;
     border: none;
     cursor: pointer;
     border: 0.09375rem solid var(--border);
     border-radius: 50%;
     padding: 0;
     margin: 0;
     width: 2rem;
     height: 2rem;
     position: relative;
     box-shadow: none;
     transition: all 0.5s ease;
   }
   button.incart {
     background-color: #270404;
   }
 
   button::after,
   button::before {
     content: "";
     position: absolute;
     top: 50%;
     left: 50%;
     background-color: var(--cross);
     transform: translate(-50%, -50%) rotate(0);
     border: none;
     box-shadow: none;
     transition: all 0.5s ease;
   }
 
   button::after {
     width: 1.1rem;
     height: 0.093rem;
   }
   button::before {
     height: 1.1rem;
     width: 0.093rem;
   }
   button.incart::after {
     height: 0.095rem;
     width: 1.1rem;
     transform: translate(-50%, -50%) rotate(360deg);
   }
   button.incart::before {
     width: 0.095rem;
     height: 1.1rem;
     transform: translate(-50%, -50%) rotate(360deg);
   }
 
   :global(.add-to-cart-animated-element) {
     background-color: #fff;
     position: fixed !important;
     top: var(--start-y_);
     left: var(--start-x_);
     width: var(--width_) !important;
     height: var(--height_) !important;
     z-index: 50;
     animation-name: movetocart;
     animation-duration: var(--duration_);
     animation-timing-function: ease-out;
     transform-origin: top left;
   }
   @keyframes movetocart {
     0% {
       opacity: 0.2;
     }
 
     100% {
       opacity: 0;
       transform: translate(0, 0) scale(0.1);
     }
   }
 </style>
 